"use strict";
// @ts-ignore
try {
    self['workbox:window:6.5.0'] && _();
}
catch (e) { }
